import { z } from 'zod';
import { Option } from '../../types/Option';

export type ConductorMaterial = 'aluminum' | 'copper';

const options = [
    { value: 'aluminum', label: 'Aluminum' },
    { value: 'copper', label: 'Copper' },
] as Option<ConductorMaterial>[];

const NECOptions = [
    { value: 'aluminum', label: 'Aluminum' },
    { value: 'copper', label: 'Copper' },
    { value: 'nickel', label: 'Nickel' },
    { value: 'nickel-coated-copper', label: 'Nickel-coated copper' },
    { value: 'copper-clad-aluminum', label: 'Copper-clad aluminum' },
] as Option<ConductorMaterial>[];

const validator = z.enum(['aluminum', 'copper']);

const NECValidator = z.enum(['aluminum', 'copper', 'nickel', 'nickel-coated-copper', 'copper-clad-aluminum']);

export const ConductorMaterial = {
    validator,
    options,
    NECValidator,
    NECOptions,
};
